/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    common: {
      init: function () {
        // JavaScript to be fired on all pages

        /* HEADER COLOR CHANGE */
        var sticky_navigation_offset_top = 0;
        var sticky_navigation = function () {
          var scroll_top = $(window).scrollTop();
          if (scroll_top > sticky_navigation_offset_top) {
            $("header.banner").addClass("scrolled");
            $(".sf-navicon-button").addClass("scrolled");
          } else {
            $("header.banner").removeClass("scrolled");
            $(".sf-navicon-button").removeClass("scrolled");
          }
        };
        sticky_navigation();

        $(window).on("scroll", function () {
          sticky_navigation();
        });
        /* END hEADER COLOR CHANGE */

        /** SHOW AND HIDE SEARCH BAR **/
        $("header .icon-search")
          .closest("a")
          .click(function () {
            $("#header-main").fadeToggle("fast", function () {
              $("#header-search").fadeToggle("slow").removeClass("hide");
              $('#header-search input[type="text"]').focus();
            });
            return false;
          });
        $("header #search-close").click(function () {
          $("#header-search").fadeToggle("fast", function () {
            $("#header-main").fadeToggle("slow");
          });
        });
        // Search Submit
        $("#header-search").submit(function (e) {
          var s = $(this).find('input[type="text"]');
          if (!s.val()) {
            e.preventDefault();
            shake($(this).find('input[type="text"]'));
            $(this).find('input[type="text"]').focus();
          }
        });
        // Shake Animation
        function shake(div) {
          var interval = 100;
          var distance = 10;
          var times = 4;

          $(div).css("position", "relative");
          for (var iter = 0; iter < times + 1; iter++) {
            $(div).animate(
              { left: iter % 2 === 0 ? distance : distance * -1 },
              interval
            );
          }
          $(div).animate({ left: 0 }, interval);
        }
        /** END SHOW OR HIDE SEARCH BAR **/

        /** ANIMATED ANCHOR LINKS **/
        $(document).on("click", 'a[href*="#"]:not([href="#"])', function () {
          if (
            location.pathname.replace(/^\//, "") ===
              this.pathname.replace(/^\//, "") &&
            location.hostname === this.hostname
          ) {
            var target = $(this.hash);
            var $this = this;
            target = target.length
              ? target
              : $("[name=" + this.hash.slice(1) + "]");
            if (target.length) {
              $("html,body").animate(
                {
                  scrollTop:
                    target.offset().top -
                    $("header.banner").outerHeight() -
                    $("#cruise-anchor-links").outerHeight() -
                    $("#wpadminbar").outerHeight(),
                },
                500,
                function () {
                  location.hash = $this.hash;
                }
              );
              return false;
            }
          }
        });
        /** END ANIMATED ANCHOR LINKS **/

        /* NUMBER TICKER UPON VIEW */
        $(window).load(function () {
          tickers();
        });
        $(window).scroll(function () {
          tickers();
        });
        function tickers() {
          $(".ticker:in-viewport:not(.viewed)").each(function () {
            $(this)
              .countTo({
                to: parseInt($(this).html()),
                speed: Math.ceil(Math.random() * 1000) + 1500,
              })
              .addClass("viewed");
          });
        }

        /* :in-viewport */
        (function ($) {
          $.belowthefold = function (element, settings) {
            var fold = $(window).height() + $(window).scrollTop();
            return fold <= $(element).offset().top - settings.threshold;
          };
          $.abovethetop = function (element, settings) {
            var top = $(window).scrollTop();
            return (
              top >=
              $(element).offset().top + $(element).height() - settings.threshold
            );
          };
          $.rightofscreen = function (element, settings) {
            var fold = $(window).width() + $(window).scrollLeft();
            return fold <= $(element).offset().left - settings.threshold;
          };
          $.leftofscreen = function (element, settings) {
            var left = $(window).scrollLeft();
            return (
              left >=
              $(element).offset().left + $(element).width() - settings.threshold
            );
          };
          $.inviewport = function (element, settings) {
            return (
              !$.rightofscreen(element, settings) &&
              !$.leftofscreen(element, settings) &&
              !$.belowthefold(element, settings) &&
              !$.abovethetop(element, settings)
            );
          };
          $.extend($.expr[":"], {
            "below-the-fold": function (a, i, m) {
              return $.belowthefold(a, { threshold: 0 });
            },
            "above-the-top": function (a, i, m) {
              return $.abovethetop(a, { threshold: 0 });
            },
            "left-of-screen": function (a, i, m) {
              return $.leftofscreen(a, { threshold: 0 });
            },
            "right-of-screen": function (a, i, m) {
              return $.rightofscreen(a, { threshold: 0 });
            },
            "in-viewport": function (a, i, m) {
              return $.inviewport(a, { threshold: 0 });
            },
          });
        })(jQuery);

        /* countTo */
        (function ($) {
          $.fn.countTo = function (options) {
            // merge the default plugin settings with the custom options
            options = $.extend({}, $.fn.countTo.defaults, options || {});

            // how many times to update the value, and how much to increment the value on each update
            var loops = Math.ceil(options.speed / options.refreshInterval),
              increment = (options.to - options.from) / loops;

            return $(this).each(function () {
              var _this = this,
                loopCount = 0,
                value = options.from,
                interval = setInterval(updateTimer, options.refreshInterval);

              function updateTimer() {
                value += increment;
                loopCount++;
                $(_this).html(value.toFixed(options.decimals));

                if (typeof options.onUpdate === "function") {
                  options.onUpdate.call(_this, value);
                }

                if (loopCount >= loops) {
                  clearInterval(interval);
                  value = options.to;

                  if (typeof options.onComplete === "function") {
                    options.onComplete.call(_this, value);
                  }
                }
              }
            });
          };

          $.fn.countTo.defaults = {
            from: 0, // the number the element should start at
            to: 100, // the number the element should end at
            speed: 1000, // how long it should take to count between the target numbers
            refreshInterval: 100, // how often the element should be updated
            decimals: 0, // the number of decimal places to show
            onUpdate: null, // callback method for every time the element is updated,
            onComplete: null, // callback method for when the element finishes updating
          };
        })(jQuery);
        /* END NUMBER TICKER UPON VIEW */

        /* HIDE GOOGLE TRANSLATE  */
        var googleTransltateElement = $("#google-translate"),
          googleTranslateClose = googleTransltateElement.find(
            ".icon-plus-circled"
          );

        function setCookie(cname, cvalue, exdays) {
          var d = new Date();
          d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
          var expires = "expires=" + d.toUTCString();
          document.cookie = cname + "=" + cvalue + "; " + expires;
        }

        function getCookie(cname) {
          var name = cname + "=";
          var ca = document.cookie.split(";");
          for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === " ") {
              c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
              return c.substring(name.length, c.length);
            }
          }
          return "";
        }

        function checkTranslateCookie() {
          var translateCookie = getCookie("hideTranslate");
          if (translateCookie === "") {
            googleTransltateElement.removeClass("hide");
          }
        }

        checkTranslateCookie();

        googleTranslateClose.on("click", function () {
          googleTransltateElement.hide();
          setCookie("hideTranslate", "hide", 1);
        });
        /* END HIDE GOOGLE TRANSLATE  */
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },
    // Home page
    home: {
      init: function () {
        // JavaScript to be fired on the home page

        /** VIDEO BG */
        var bgndVideo = $("#bgndVideo");
        if (bgndVideo.length) {
          bgndVideo.YTPlayer();
        }
        /** VIDEO BG */

        /** HOMEPAGE SCROLL ARROW FUNCTION **/
        $("#homepage-arrow .icon-down-open").click(function () {
          $("html,body").animate(
            {
              scrollTop:
                $("#homepage-header").outerHeight() -
                $("#header-main").outerHeight(),
            },
            500
          );
        });
        /** END HOMEPAGE SCROLL ARROW FUNCTION **/

        $(window).load(function () {
          $(".vc_video-bg iframe").each(function () {
            var url = $(this).attr("src");
            $(this).attr("src", url + "&wmode=transparent");
          });
        });
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      },
    },
    // FAQ page
    faq: {
      init: function () {
        $(".vc_toggle_title").each(function () {
          var pageContent = $(this).html();
          pageContent = pageContent.replace(
            /falkor(?!<\/em>|'s<\/em>|<\/i>|'s<\/i>)/gi,
            "<em>Falkor</em>"
          );
          $(this).html(pageContent);
        });
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      },
    },
    // Cruises us page.
    cruises: {
      init: function () {
        // JavaScript to be fired on the about us page

        /* ACTIVE FILTERS */
        $("#region-filters").on("click", "a", function (event) {
          activeFilter = $(this).html();
          if (activeFilter === "All Regions") {
            $(this).siblings("p").html("Cruise Topics");
          } else {
            $(this).siblings("p").html(activeFilter);
          }
        });
        $("#topic-filters").on("click", "a", function (event) {
          activeFilter = $(this).html();
          if (activeFilter === "All Topics") {
            $(this).siblings("p").html("Cruise Topics");
          } else {
            $(this).siblings("p").html(activeFilter);
          }
        });
        $("#date-filters").on("click", "a", function (event) {
          activeFilter = $(this).html();
          if (activeFilter === "All Years") {
            $(this).siblings("p").html("Cruise Year");
          } else {
            $(this).siblings("p").html(activeFilter);
          }
        });
        /* END ACTIVE FILTERS */

        /** ISOTOPE **/
        function getHashFilter() {
          // get filter=filterName
          var matches = location.hash.match(/filter=([^&]+)/i);
          var hashFilter = matches && matches[1];
          return hashFilter && decodeURIComponent(hashFilter);
        }
        if ($(".gallery-container").length > 0) {
          initProjectIsotope();
        }
        function initProjectIsotope() {
          var hashFilter = getHashFilter();
          var $container = $(".gallery-container").imagesLoaded(function () {
            $(".gallery-container").isotope({
              itemSelector: ".gallery-item",
              masonry: {
                columnWidth: ".gallery-sizer",
              },
              filter: hashFilter,
            });
          });
          // flatten object by concatting values
          function concatValues(obj) {
            var value = "";
            for (var prop in obj) {
              value += obj[prop];
            }
            return value;
          }

          // store filter for each group
          var filters = {};

          $("#cruise-filters").on("click", "a", function () {
            var $this = $(this);

            // Remove .active-filter class and add to current filter
            $(".dropdown a").removeClass("active-filter");
            $this.addClass("active-filter");
            // get group key
            var $buttonGroup = $this.parents(".dropdown").find("ul");
            var filterGroup = $buttonGroup.attr("data-filter-group");
            // set filter for group
            filters[filterGroup] = $this.attr("data-filter");
            // combine filters
            var filterValue = concatValues(filters);
            $container.isotope({ filter: filterValue });
            location.hash = "filter=" + encodeURIComponent(filterValue);
            if (typeof ga === "function") {
              // ga('send', 'pageview', {'page': '/gallery/', 'title': 'Work - Filter: ' + filterGroup});
            }

            return false;
          });

          // flatten object by concatting values
          function concatValues(obj) {
            var value = "";
            for (var prop in obj) {
              value += obj[prop];
            }
            return value;
          }

          $(".gallery-filters a").click(function () {});
        }
        /** END ISOTOPE **/
      },
    },
    single_cruise: {
      init: function () {
        // JavaScript to be fired on the about us page

        /** STICKY NAV FOR CRUISE PAGES **/
        // Get an array of all the sidebar links and store it as "anchorLinks"
        var anchorLinks = $("#cruise-anchor-links a")
          .map(function () {
            // Essentially we're finding all the <a> tags in ".programs-side-nav .menu" and running a function on each one
            return this.href.substr(this.href.indexOf("#")); // Even though the URL isn't coded into the link, this.href still returns http://dev-kendeda.thisisvisceral.com/#overview so we use JavaScripts substr function to just get the #overview part
          })
          .toArray(); // toArray takes all of these results and pushes them into an array
        // Will return this: [ "#vision", "#overview", "#goals", "#grants" ]

        function stickynavSetup() {
          var scrollTop = $(window).scrollTop();

          // This code runs inside stickynavSetup which means it runs anytime the page loads or the user scrolls
          var activeState = ""; // create a variable to store the active state

          // The for loop cycles through all the links in anchorLinks
          for (var i = 0; i < anchorLinks.length; i++) {
            // Create a variable for the sidebar link
            var sbLink = anchorLinks[i]; // Will return #vision (or #overview, etc.)
            // Create a variable for the position of the corresponding anchor link.  I.e. if the link is "#overview" we're looking for an anchor named "overview"
            var anchorPos = $("a[name=" + sbLink.substring(1) + "]").offset()
              .top; // The substring(1) function just trims the first character so we're getting top offset value of a[name=overview]

            if (
              scrollTop >=
              anchorPos -
                35 -
                $("#cruise-anchor-links").outerHeight() -
                $("header.banner").outerHeight() -
                $("#wpadminbar").outerHeight()
            ) {
              // if our current scroll position is greater than the position of the corresponding anchor
              activeState = sbLink;
            }
          }

          if (scrollTop >= $(".masthead").outerHeight() - 58) {
            // if current scroll position is greater than the height of the masthead accounting for header
            $("#cruise-anchor-links")
              .addClass("fixed")
              .css({
                top:
                  $("header.banner").outerHeight() +
                  $("#wpadminbar").outerHeight(),
              });
            $("#cruise-anchor-links a").removeClass("active-anchor"); // Remove active class from ALL sidebar links
            $('a[href="' + activeState + '"]').addClass("active-anchor"); // Add it only on the one that corresponds to the current section
            // NOTE: While this code seems to work just fine, there MAY be a better way of doing this than looping through all sidebar links everytime you scroll
            // You could probably reverse the logic here and get an array of all the anchors and then compare those to the current scroll position and then find the corresponding sidebar link
            // I'm not sure that'd make much difference though.  If this were a mission critical app here .8ms made a huge difference, then maybe I'd try it and compare performance.
          } else {
            $("#cruise-anchor-links").removeClass("fixed");
          }
        }
        $(window).load(function () {
          stickynavSetup();
        });
        $(window).scroll(function () {
          stickynavSetup();
        });
        /** END STICKY NAV FOR CRUISE PAGES **/

        /** MORE TEXT ANIMATION - Cruise pages**/
        $("#more-text .vc_inner ").css({ display: "none" });
        $("#more-text .vc_btn3")
          .parent(".vc_btn3-container")
          .removeClass("hidden");
        $("#more-text .vc_btn3").on("click", function (event) {
          event.preventDefault();
          $("#more-text .vc_inner ").slideToggle("300");
          $(this).html(
            $(this).text() === "Show More" ? "Show Less" : "Show More"
          );
          $(this).toggleClass("open");
        });
        /** END MORE TEXT ANIMATION **/
      },
    },

    // Cruises us page.
    single_cruise_log_post: {
      init: function () {
        // JavaScript to be fired on the about us page

        /** FLEXSLIDER **/
        // Set up breakpoints for number of items in view
        var $window = $(window),
          flexslider;

        // If
        function getGridSize() {
          return window.innerWidth < 992 ? 1 : 3;
        }

        $window.load(function () {
          $(".flexslider-carousel").flexslider({
            selector: ".slides .carousel-item",
            animation: "slide",
            animationLoop: true,
            itemWidth: 470,
            maxItems: getGridSize(),
            minItems: getGridSize(),
            start: function (slider) {
              flexslider = slider;
            },
          });
        });
        $window.resize(function () {
          var gridSize = getGridSize();
          flexslider.vars.minItems = gridSize;
          flexslider.vars.maxItems = gridSize;
        });
        /** END FLEXSLIDER **/
      },
    },

    // Gallery page
    gallery: {
      init: function () {
        // JavaScript to be fired on the about us page

        /** FLEXSLIDER **/
        $(window).load(function () {
          $(".flexslider").flexslider({
            animation: "slide",
            slideshowSpeed: 8000,
          });
        });
        /** END FLEXSLIDER **/
      },
    },

    // Gallery Media Type Archives
    tax_media_type: {
      init: function () {
        /** FLEXSLIDER **/
        $(window).load(function () {
          $(".flexslider").flexslider({
            animation: "slide",
            slideshowSpeed: 8000,
          });
        });
        /** END FLEXSLIDER **/
      },
    },

    news: {
      init: function () {
        /* SHOW HIDE FILTERS */
        $("#filter-button").click(function () {
          $(".filter-box ul").slideToggle("fast", function () {});
        });
        /* END SHOW HIDE FILTERS */
      },
    },

    category: {
      init: function () {
        /* SHOW HIDE FILTERS */
        $("#filter-button").click(function () {
          $(".filter-box ul").slideToggle("fast", function () {});
        });
        /* END SHOW HIDE FILTERS */
      },
    },

    single_collection: {
      init: function () {
        // JavaScript to be fired on the about us page

        /** ISOTOPE **/
        function getHashFilter() {
          // get filter=filterName
          var matches = location.hash.match(/filter=([^&]+)/i);
          var hashFilter = matches && matches[1];
          return hashFilter && decodeURIComponent(hashFilter);
        }
        if ($(".gallery-container").length > 0) {
          initProjectIsotope();
        }
        function initProjectIsotope() {
          var hashFilter = getHashFilter();

          var $container = $(".gallery-container").imagesLoaded(function () {
            $(".gallery-container").isotope({
              itemSelector: ".gallery-item",
              masonry: {
                columnWidth: ".gallery-sizer",
              },
              filter: hashFilter,
            });
          });
          $(".gallery-filters a").click(function () {
            // Remove .active-filter class and add to current filter
            $(".gallery-filters a").removeClass("active-filter");
            $(this).addClass("active-filter");
            // Add filter class to URL hash
            var filterValue = $(this).attr("data-filter");
            $container.isotope({ filter: filterValue });
            location.hash = "filter=" + encodeURIComponent(filterValue);
            if (typeof ga === "function") {
              ga("send", "pageview", {
                page: "/gallery/",
                title: "Work - Filter: " + filterValue,
              });
            }

            return false;
          });
        }
        /** END ISOTOPE **/

        /** MAGNIFIC GALLERY **/
        $(document).ready(function () {
          $(".magnific-gallery").each(function () {
            // the containers for all your galleries
            $(this).magnificPopup({
              delegate: "a", // the selector for gallery item
              type: "image",
              tLoading: "Loading image #%curr%...",
              gallery: {
                enabled: true,
                arrowMarkup:
                  '<button class="mfp-arrow mfp-arrow-%dir%"></button>', // markup of an arrow button
                preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
              },
              image: {
                tError:
                  '<a href="%url%">The image #%curr%</a> could not be loaded.',
                titleSrc: function (item) {
                  var html = "";
                  if (item.el.attr("title") !== "") {
                    html +=
                      '<h4 class="lb-title">' + item.el.attr("title") + "</h4>";
                  }
                  if (item.el.attr("data-description") !== "") {
                    html +=
                      '<p class="lb-description">' +
                      item.el.attr("data-description") +
                      "</p>";
                  }
                  if (item.el.attr("data-credit") !== "") {
                    html += '<p class="lb-credit-name">Photo credit: ';
                    if (item.el.attr("data-credit-url") !== "") {
                      html +=
                        '<a href="' +
                        item.el.attr("data-credit-url") +
                        '">' +
                        item.el.attr("data-credit") +
                        "</a>";
                    } else {
                      html += item.el.attr("data-credit") + "</p>";
                    }
                    html +=
                      '<p class="lb-download"><a href="' +
                      item.el.attr("data-download-url") +
                      '" download>DOWNLOAD</a></p>';
                  }
                  return html;
                },
              },
            });
          });
        });
        /** END MAGNIFIC GALLERY **/

        // Add Fancybox functionality on post images that link to their image
        $(
          '.entry-content a[href*=".jpg"], .entry-content a[href*=".jpeg"], .entry-content a[href*=".png"], figure.wp-caption a[href*=".jpg"], figure.wp-caption a[href*=".jpeg"], figure.wp-caption a[href*=".png"], .timeline-block a[href*=".jpg"], .timeline-block a[href*=".jpeg"], .timeline-block a[href*=".png"]'
        ).each(function () {
          var srcset = $(this).children("img").attr("srcset"),
            src = $(this).children("img").attr("src");

          if (srcset) {
            // for images that already have srcset set
            $(this).attr("data-srcset", srcset).attr("data-fancybox", "images");
          } else {
            // just assign the href of the a to the value of the img src, which will be a cropped size
            $(this).attr("href", src).attr("data-fancybox", "images");
          }
        });

        $(
          '.entry-content a[href*=".jpg"], .entry-content a[href*=".jpeg"], .entry-content a[href*=".png"], figure.wp-caption a[href*=".jpg"], figure.wp-caption a[href*=".jpeg"], figure.wp-caption a[href*=".png"], .timeline-block a[href*=".jpg"], .timeline-block a[href*=".jpeg"], .timeline-block a[href*=".png"]'
        ).fancybox({
          loop: true,
        });
      },
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, "_").split(/\s+/), function (
        i,
        classnm
      ) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, "finalize");
      });

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
